<div
  id="asset-type-table-container"
  class="matp-table-container tw-max-h-[calc(100vh_-_200px)]"
>
  <div class="matp-table-actions-area">
    <div class="matp-table-actions">
      <button
        mat-raised-button
        id="filter-clear-btn"
        class="tw-mr-2"
        (click)="clearFilters()"
      >
        <mat-icon>restart_alt</mat-icon>
        <span>クリア</span>
      </button>
      <button
        mat-raised-button
        id="add-btn"
        color="primary"
        class="tw-mr-2"
        (click)="created.emit()"
        [disabled]="isDisabled"
      >
        <mat-icon>add</mat-icon>
        <span>新規登録</span>
      </button>
      <button
        mat-raised-button
        id="delete-all-btn"
        color="warn"
        class="tw-mr-2"
        (click)="bulkDelete()"
        [disabled]="isDisabled || isBulkDeleteButtonDisable"
      >
        <mat-icon>delete</mat-icon>
        <span>一括削除</span>
      </button>
    </div>
  </div>

  <div class="matp-table-area">
    <table
      id="asset-type-table"
      class="matp-table"
      mat-table
      matSort
      [matSortActive]="initSortState.active"
      [matSortDirection]="initSortState.direction"
      [dataSource]="dataSource"
    >
      <!-- チェックボックス -->
      <ng-container matColumnDef="checkbox">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="matp-table-header-middle !tw-min-w-min"
        >
          <mat-checkbox
            name="selectAll"
            color="primary"
            (change)="
              $event ? toggleAllRows() : null; updateBulkDeleteButtonState()
            "
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
          ></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox
            name="select"
            color="primary"
            (click)="$event.stopPropagation()"
            (change)="
              $event ? selection.toggle(element) : null;
              updateBulkDeleteButtonState()
            "
            [checked]="selection.isSelected(element)"
          ></mat-checkbox>
        </td>
      </ng-container>

      <!-- アセット名 -->
      <ng-container matColumnDef="assettypeName">
        <th mat-header-cell *matHeaderCellDef>
          <div
            mat-sort-header
            class="matp-table-header-title tw-min-w-[140px] tw-text-nowrap"
          >
            設定テンプレート名
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="assetTypeName"
              type="text"
              [(ngModel)]="assetTypeNameKeyword"
              (keyup)="dataSource.filter = assetTypeNameKeyword"
            />
            <button
              id="assettypename-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearAssetTypeNameFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell name="assettypeName" *matCellDef="let element">
          {{ element.assettypeName }}
        </td>
      </ng-container>

      <!-- デバイス種類ID -->
      <ng-container matColumnDef="deviceTypeId">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title tw-text-nowrap">
            デバイス種類
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <mat-select
              [(ngModel)]="selectedDeviceType"
              name="deviceTypeFilter"
              panelClass="matp-table-select-panel"
              (selectionChange)="applyFilter()"
            >
              <mat-option [value]="null"></mat-option>
              <mat-option
                *ngFor="let deviceType of deviceTypes"
                [value]="deviceType"
              >
                {{ deviceType }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        <td mat-cell name="deviceTypeId" *matCellDef="let element">
          {{ element.deviceTypeDisplayName }}
        </td>
      </ng-container>

      <!-- 最終更新日時 -->
      <ng-container matColumnDef="updatedAt">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title tw-text-nowrap">
            最終更新日時
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              name="updatedAt"
              matInput
              appAutocompleteOff
              type="text"
              [(ngModel)]="updatedAtKeyword"
              (keyup)="dataSource.filter = updatedAtKeyword"
            />
            <button
              id="updatedAt-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearUpdatedAtFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td name="updatedAt" mat-cell *matCellDef="let element">
          {{ element.updatedAt | date: "yyyy/MM/dd HH:mm:ss" }}
        </td>
      </ng-container>

      <!-- 更新者 -->
      <ng-container matColumnDef="updatedBy">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title tw-text-nowrap">
            更新者
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              name="updatedBy"
              matInput
              appAutocompleteOff
              type="text"
              [(ngModel)]="updatedByKeyword"
              (keyup)="dataSource.filter = updatedByKeyword"
            />
            <button
              id="updatedBy-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearUpdatedByFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td name="updatedBy" mat-cell *matCellDef="let element">
          {{ element.updatedBy }}
        </td>
      </ng-container>

      <!-- 操作 -->
      <ng-container matColumnDef="operation">
        <th mat-header-cell *matHeaderCellDef class="!tw-min-w-56 tw-max-w-56">
          <div class="matp-table-header-title tw-text-nowrap">操作</div>
        </th>
        <td mat-cell *matCellDef="let element" class="!tw-w-56">
          <div class="tw-flex tw-justify-center tw-gap-1">
            <div class="tw-mx-0">
              <button
                mat-stroked-button
                id="copy-btn"
                color="primary"
                (click)="copied.emit(element)"
                [disabled]="isDisabled"
              >
                <mat-icon>content_copy</mat-icon>
                <span>コピー</span>
              </button>
            </div>
            <div class="tw-mx-0">
              <button
                mat-stroked-button
                id="edit-btn"
                color="primary"
                (click)="updated.emit(element)"
              >
                <mat-icon>edit</mat-icon>
                <span>編集</span>
              </button>
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <mat-paginator
    id="asset-type-table-paginator"
    [length]="dataSource.filteredData.length"
    hidePageSize
    showFirstLastButtons
  >
  </mat-paginator>
</div>
